export default {
  /**
   * Click interceptor function to handle öV-Pad classic internal html links with vue router (avoids page reload). Used for example in news module to allow internal links from provided content.
   * Interceptor code found at https://dennisreimann.de/articles/delegating-html-links-to-vue-router.html
   * @param {*} event the native event
   * @param {*} $router the vue router
   * @param {*} rootState the vuex rootState
   */
  clickInterceptor(event, $router, rootState) {
    // ensure we use the link, in case the click has been received by a subelement
    let { target } = event;
    console.debug('clickInterceptor');
    // console.log('click interceptor called on ', target);
    while (target && target.tagName !== 'A') target = target.parentNode;
    if (target === null) {
      // vuetify component clicks arrive here. Resume default behavior
      // console.log('click interceptor. Vuetify component clicks arrive here and default behavior is resumed');
      event.returnValue = true;
      return;
    }
    if (target.protocol.includes('tel')) {
      // console.log('tel protocol found. Resume default behavior');
      event.returnValue = true;
      return;
    }
    // handle only links that do not reference external resources
    if (target && target.href && target.href.startsWith('mailto:')) {
      // let the browser handle mailto links
      // TODO test this mailto
      console.log('Interceptor: Detected a mailto: link, letting the browser handle it');
    } else if (target && target.href && target.matches("a:not([href*='://'])")) {
      console.log('Interceptor: handle only links that do not reference external resources');
      // some sanity checks taken from vue-router:
      // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
      const { altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented } = event;
      // don't handle with control keys
      if (metaKey || altKey || ctrlKey || shiftKey) return;
      // don't handle when preventDefault called
      if (defaultPrevented) return;
      // don't handle right clicks
      if (button !== undefined && button !== 0) return;
      // don't handle if `target="_blank"`
      if (target && target.getAttribute) {
        const linkTarget = target.getAttribute('target');
        if (/\b_blank\b/i.test(linkTarget)) return;
      }
      // don't handle same page links/anchors
      const url = new URL(target.href);
      const to = url.pathname;
      if (window.location.pathname !== to && event.preventDefault) {
        console.log('Click interceptor. Handle only links that do not reference external resources');
        //console.log(`Use vue router.push(${to})`);
        //console.log(`search (${url.search.substr(1)})`);
        const urlParams = new URLSearchParams(url.search.substr(1));

        let adaptedTo = to;

        if (to.includes('/upload/video')) {
          // video module öV-Pad classic links in form /upload/videos?videoid=[id]
          let videoid = urlParams.get('videoid');
          let video = rootState.videos.videosById[videoid];
          if (video) {
            adaptedTo = `/videos/${video.instance}/${videoid}`;
          }
        } else if (to.includes('/upload/document')) {
          // document module öV-Pad classic links in form /upload/document?documentid=[id]
          let documentId = urlParams.get('documentid');
          let doc = rootState.documents.documentsById[documentId];
          if (doc) {
            adaptedTo = `/documents/${doc.instance}/${documentId}`;
          }
        } else if (to.includes('/upload/media')) {
          // media module öV-Pad classic links in form /upload/media?mediaid=[id]
          let mediaId = urlParams.get('mediaid');
          let media = rootState.media.containersById[mediaId];
          if (media) {
            adaptedTo = media.idParentFk ? `/media/${media.moduleId}/${media.idParentFk}/${mediaId}` : `/media/${media.moduleId}/${media.moduleId}/${mediaId}`;
          }
        } else if (to.includes('/upload/forms')) {
          // forms module öV-Pad classic links in form /upload/forms?formid=[id]
          let formId = urlParams.get('formid');
          let form = rootState.forms.formsById[formId];
          if (form) {
            adaptedTo = `/forms/${form.instance}/${formId}`;
          }
        }
        console.log('Interceptor found öv-pad classic link that needs to be routed internally', adaptedTo);
        event.preventDefault();
        if (adaptedTo) {
          $router.push(adaptedTo);
        }
      }
    } else {
      if (target) {
        console.log('Click interceptor: Open external links in a new tab no matter if target=_blank');
        // Open external links in a new tab no matter if target=_blank
        // ToDo: Check if internal weblinks work
        //console.log(`external link found ${target.href}`);

        if (target.target === '_blank') {
          event.preventDefault();
          window.open(target.href, '_blank');
        }
      } else {
        console.log('interceptor: no match found. Resume default behavior');
        event.returnValue = true;
      }
    }
  },
};
